import Swal from 'sweetalert2';

export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('access_token');

  const defaultOptions = {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...options,
  };

  try {
    const response = await fetch(url, defaultOptions);

    if (response.status === 401) {
      // Token inválido o expirado
      Swal.fire('Sesión expirada', 'Por favor, inicia sesión nuevamente.', 'warning').then(() => {
        localStorage.removeItem('access_token');  // Elimina el token
        window.location.href = '/';  // Redirige al login
      });
      return null;  // Detenemos la ejecución
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al realizar la solicitud:', error);
    Swal.fire('Error', 'Ocurrió un problema al realizar la solicitud.', 'error');
    return null;
  }
};
